import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiArrowRight}=FiIcons;

const HeroSection=()=> {
const whatsappUrl="https://wa.me/5214775954969?text=Quiero%20tener%20ticket%20factura%20en%20mi%20restaurante";
const whatsappImageUrl="https://wa.me/5214775954969?text=Quiero%20implementar%20ticket%20factura%20en%20mi%20restaurante";

return ( 
<section className="relative min-h-screen flex items-center py-20 bg-gray-900 text-white overflow-hidden"> 
{/* Background Image with Overlay */} 
<div className="absolute inset-0 z-0"> 
<img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80" alt="Restaurant Technology Background" className="w-full h-full object-cover opacity-30" /> 
<div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black opacity-90"></div> 
</div> 
<div className="container mx-auto px-4 relative z-10"> 
<div className="grid md:grid-cols-12 gap-8 items-center"> 
{/* Left Content - Text */} 
<div className="md:col-span-6"> 
<motion.div initial={{opacity: 0,y: 30}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8}} > 
<h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6"> <span className="text-orange-500">INCREMENTA LAS VENTAS</span> EN TU RESTAURANTE </h1> 
<p className="text-xl md:text-2xl mb-8 text-gray-300"> Transforma la experiencia de facturación en un momento WOW que fideliza clientes,genera recomendaciones y aumenta significativamente tus ingresos. </p> 
<motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold text-xl px-8 py-4 rounded-full shadow-lg transform transition-all duration-300 flex items-center" whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} > QUIERO INCREMENTAR MIS VENTAS <SafeIcon icon={FiArrowRight} className="ml-2" /> </motion.a> 
</motion.div> 
</div> 
{/* Right Content - Image */} 
<div className="md:col-span-6"> 
<motion.div className="rounded-xl overflow-hidden shadow-2xl" initial={{opacity: 0,x: 30}} animate={{opacity: 1,x: 0}} transition={{duration: 0.8,delay: 0.3}} > 
<a href={whatsappImageUrl} target="_blank" rel="noopener noreferrer" className="block cursor-pointer transform transition-transform duration-300 hover:scale-105" > 
<img src="https://www.ticketfactura.com/wp-content/uploads/2025/09/claudia-ticket-factura-incrementa-ventas.jpg" alt="Claudia - Ticket Factura Incrementa Ventas - Haz clic para contactar" className="w-full h-auto rounded-xl shadow-2xl" /> 
</a> 
<div className="bg-gradient-to-r from-orange-500 to-red-600 p-4 text-center"> 
<p className="font-bold"> Descubre cómo puedes transformar tu restaurante y aumentar tus ventas </p> 
</div> 
</motion.div> 
</div> 
</div> 
</div> 
</section> 
);};
export default HeroSection;